export default function trackForInstall(event, data, installation) {
  return window.globalLibs.trackForInstall(event, data, installation);
}
